<template>
    
                <div class="news-items mt54">

                    <a href="https://mp.weixin.qq.com/s/mt7K9MBlhd65bm7hCbaUJA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250606/001.png" alt="冯文滔受邀出席2025中国国际大健康产业文化节暨第36届健博会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">06/06<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">冯文滔受邀出席2025中国国际大健康产业文化节暨第36届健博会</div>
                                <div class="desc">6月6日，2025中国国际大健康产业文化节暨第36届国际大健康产业交易博览会在广州保利世贸博览馆隆重开幕，融贯国际董事长冯文滔受邀致辞。本届“健博会”以“大健康、大平台、大产业；新时代、新科技、新征程”为主题，紧紧围绕“医+康+养”共设，“医疗器械暨医院建设展”“银发经济康养展”“营养健康与健康原料展”三大主题展联动，全方位构建大健康产业生态。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/JLxJNrYgMLstKk9Jsjbi-g" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250515/001.jpg" alt="中药质量研究讲座助中医药国际化" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">05/15<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">中药质量研究讲座助中医药国际化</div>
                                <div class="desc">为促进中医药学术交流，推动中药质量标准研究的国际化发展，澳门城市大学邀请上海中医药大学中医药国际标准化研究院院长、中国科学院上海药物研究所研究员、中药标准化技术国家工程研究中心主任果德安教授主讲城大大师讲座，以「中药质量与标准研究策略及国际化发展」为题，带来专题学术分享，深入探讨中药质量控制的关键技术与国际标准体系建设，助力中医药现代化与全球化发展。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/ULxzpf2WehUz3r63dGkfDg" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250322/001.jpg" alt="融贯国际与丹阳考察团共话产业升级，探索数字化出海新路径" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">03/22<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际与丹阳考察团共话产业升级，探索数字化出海新路径</div>
                                <div class="desc">2025年3月22日，江苏省丹阳市人大常委会主任，丹阳眼镜产业链链长赵立群率眼镜产业链考察团到访横琴粤澳深度合作区，与融贯国际围绕“数字技术赋能产业出海”展开务实交流。双方结合丹阳眼镜产业实际需求与融贯国际平台资源，聚焦跨境数据合规流动、品牌国际化孵化及供应链服务升级等议题，探索借力澳门“政策试验田”与“国际商贸桥”双重角色，为产业升级出海夯实合作基础。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/R8s7y5EdJ0BPt6x48L29sw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250321/001.jpg" alt="澳城大首推“学历+国家技能证书”创新教育模式、助力澳门青年融入湾区" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">03/21<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">澳城大首推“学历+国家技能证书”创新教育模式、助力澳门青年融入湾区</div>
                                <div class="desc">2025年3月21日，为响应国家职业教育改革政策，推动产教融合，澳门城市大学国际培训与测试中心及澳门城市大学数据科学学院、珠海市高技能人才公共实训中心（以下简称“珠海市高训中心”）为主导，联合澳门融贯投资科技发展有限公司（以下简称“融贯国际”）举办的「智启未来·AI行业互动讲堂」在澳门城市大学凼仔校区顺利举行。此次活动旨在推动「学历+国家技能证书」的创新教育模式，培养符合国家职业标准、具备行业准入资质的AI应用型人才，助力澳门青年更好地融入粤港澳大湾区的发展浪潮。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/c-UfPF9YAXUaIxa6buiB6Q" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250318/001.jpg" alt="融贯国际拜访广东省中医院珠海医院：共绘中医药发展新蓝图" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">03/18<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际拜访广东省中医院珠海医院：共绘中医药发展新蓝图</div>
                                <div class="desc">2025年3月18日，融贯国际携手融贯云洲、澳门853国际医药科技、澳门质量品牌国际认证联盟等企业及澳门协会代表，与广东省中医院珠海医院院长陈前军，党委副书记、副院长逯敏，党委委员、副院长王建春等院方领导共同探索中医药产业的未来发展之路，旨在通过深度合作，推动中医药文化的传承与创新。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/s_bKJOu4huHzjve0zMvkEA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250226/001.jpg" alt="高质量药材选品规范项目启动 专家倡议接轨国际标准推动行业升级" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">02/26<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">高质量药材选品规范项目启动 专家倡议接轨国际标准推动行业升级</div>
                                <div class="desc">2025年2月26日，由国家市场监管总局发展研究中心主办的“国创严选高质量药材选品规范” 项目启动暨研讨座谈会在横琴粤澳深度合作区举行，会议由上海中药创新成果转化中心和珠海融贯国际科技发展有限公司承办。会议启动了《高质量药材选品规范》编制工作，并邀请业内专家、企业代表及相关标准组织成员共同探讨药材产业与国际标准接轨的路径，旨在推动中医药行业高质量发展，提升中国药材全球竞争力。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s?__biz=MzU0MzkyMTQ5Nw==&mid=2247492257&idx=1&sn=c14798adf5a65c88399a95541e04ef1d&scene=21#wechat_redirect" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20250106/001.png" alt="中国农业展览协会换届大会在京召开，融贯任副会长单位" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">01/06<span>2025</span></div></div>
                            <div class="info">
                                <div class="title">中国农业展览协会换届大会在京召开，融贯任副会长单位</div>
                                <div class="desc">2025年1月6日，中国农业展览协会换届大会在北京召开，融贯受邀担任副会长单位，副总经理杨雪芬当选新届副会长。农业农村部党组成员李敬辉出席大会并作重要讲话，农业农村部市场与信息化司司长雷刘功、全国农业展览馆党委书记刘子忠、全国性行业协会商会第四联合党委纪委书记梅建彬等领导出席大会。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s?__biz=MzkzMTMxMjM1Mg==&mid=2247485446&idx=1&sn=22017ebea5fcd702f0e9b93f27f8b049&chksm=c26daf89f51a269fecf54972f9d39d88a7b9b4aa250b4ee465f9ddbb39cba1bd69db5942f9ff&token=1803358985&lang=zh_CN#rd" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/20241227/001.jpg" alt="陈祥受邀出席第三届大熊猫国家公园文创产业年会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/27<span>2024</span></div></div>
                            <div class="info">
                                <div class="title">陈祥受邀出席第三届大熊猫国家公园文创产业年会</div>
                                <div class="desc">2024年12月27日，由四川省大熊猫国家公园文化创意创新联盟、成都大熊猫旅游文化产业促进会、成都大学中国-东盟艺术学院美术与设计学院主办的第三届大熊猫国家公园文创产业年会圆满召开。澳门中葡商贸促进协会常务理事于丁，澳门质量品牌国际认证联盟秘书长陈祥，受邀出席并发表致辞。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>